import { sessionUser } from 'utility/sessionStorageHelper';

export const invoiceURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `invoicereferencesvc/v0/cust/${customerId}/user/${userId}/` + endpoint;
};
